import api from '../../../../../configurations/service';
import * as types from './mutation-types';

export const setClient = async (context) => {
  const { data } = await api().get('application.get-client');
  context.commit(types.SET_CLIENT, data);
};

export const toggleModalAdminPassword = async (context) => {
  context.commit(types.SET_MODAL_ADMIN_PASSWORD);
};

export const sendAdminPassword = async (context, adminPassword) => {
  const { data } = await api().post('application.auth-admin', { adminPassword });
  context.commit(types.SET_ADMIN_PASSWORD_IS_VALID, data.isAdmin);
};

export const cleanAdminPasswordIsValid = async (context) => {
  context.commit(types.SET_ADMIN_PASSWORD_IS_VALID, false);
};

export const getUsersClient = async (context) => {
  const { data } = await api().get('application.get-users-client-no-admin');
  context.commit(types.SET_USERS_CLIENT, data);
};

export const getCurrentUser = async (context) => {
  const { data } = await api().get('application.get-profile');
  context.commit(types.SET_CURRENT_USER, data);
};
